var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _line, _path3, _rect, _g, _path4, _path5, _path6, _path7, _path8, _path9, _circle9, _circle10, _circle11, _circle12, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5117,
    cy: 24,
    r: 16,
    fill: "#C0E5E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.51172,
    cy: 29,
    r: 2,
    fill: "#F1BC19"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0117,
    cy: 24.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5117,
    cy: 39,
    r: 1,
    fill: "#099B9B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5117,
    cy: 34,
    r: 1,
    fill: "#F1BC19"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5117,
    cy: 7,
    r: 2,
    fill: "#F1BC19"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0117,
    cy: 5.5,
    r: 0.5,
    fill: "#F1BC19"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5117,
    cy: 11,
    r: 1,
    fill: "#099B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3014 12.9474C15.3014 11.4213 16.5385 10.1842 18.0646 10.1842H23.9593C25.4853 10.1842 26.7225 11.4213 26.7225 12.9474V21.7603C26.7225 22.2794 26.0565 22.4928 25.7548 22.0704C25.4114 21.5897 24.7062 21.5634 24.3279 22.0173L23.9249 22.5009C23.541 22.9615 22.8445 22.9931 22.4206 22.5692L22.1973 22.3459C21.5426 21.6913 20.4812 21.6913 19.8265 22.3459L19.6033 22.5692C19.1793 22.9931 18.4828 22.9615 18.099 22.5009L17.6959 22.0173C17.3177 21.5634 16.6125 21.5897 16.2691 22.0704C15.9674 22.4928 15.3014 22.2794 15.3014 21.7603V12.9474Z",
    fill: "#D9D9D9",
    stroke: "#523836",
    strokeWidth: 0.368421
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5908 12.5791H24.6961",
    stroke: "#523836",
    strokeWidth: 0.368421
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.5908,
    y1: 13.4999,
    x2: 21.0119,
    y2: 13.4999,
    stroke: "#523836",
    strokeWidth: 0.368421
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3276 15.8945H17.6961M18.4329 15.8945H22.4855M17.3276 16.9998H17.6961M18.4329 16.9998H22.4855M17.3276 18.1051H17.6961M18.4329 18.1051H22.4855M17.3276 19.2103H17.6961M18.4329 19.2103H22.4855",
    stroke: "#523836",
    strokeWidth: 0.368421
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_693_431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 15,
    width: 5,
    height: 5
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.4883,
    y: 15.1558,
    width: 4.42105,
    height: 4.42105,
    fill: "#523836"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_693_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.518 19.0243V18.6282C24.3553 18.5914 24.2148 18.5208 24.0966 18.4164C23.9784 18.312 23.8917 18.1646 23.8364 17.9743L24.1772 17.8361C24.2233 17.9835 24.2916 18.0956 24.3821 18.1723C24.4727 18.2491 24.5917 18.2874 24.7391 18.2874C24.8649 18.2874 24.9716 18.259 25.0591 18.2022C25.1466 18.1454 25.1904 18.0572 25.1904 17.9374C25.1904 17.83 25.1566 17.7448 25.0891 17.6819C25.0215 17.6189 24.8649 17.5475 24.6193 17.4677C24.3553 17.3848 24.1741 17.2858 24.0759 17.1707C23.9777 17.0555 23.9285 16.9151 23.9285 16.7493C23.9285 16.5497 23.993 16.3947 24.122 16.2842C24.2509 16.1736 24.3829 16.1107 24.518 16.0953V15.7085H24.8864V16.0953C25.0399 16.1199 25.1666 16.1759 25.2664 16.2634C25.3661 16.3509 25.4391 16.4576 25.4851 16.5835L25.1443 16.7309C25.1075 16.6326 25.0553 16.5589 24.9877 16.5098C24.9202 16.4607 24.8281 16.4361 24.7114 16.4361C24.5763 16.4361 24.4735 16.4661 24.4029 16.5259C24.3323 16.5858 24.297 16.6603 24.297 16.7493C24.297 16.8506 24.343 16.9304 24.4351 16.9888C24.5272 17.0471 24.6869 17.1085 24.9141 17.173C25.1259 17.2344 25.2863 17.3319 25.3953 17.4654C25.5043 17.599 25.5588 17.7532 25.5588 17.9282C25.5588 18.1462 25.4943 18.312 25.3654 18.4256C25.2364 18.5392 25.0768 18.6098 24.8864 18.6374V19.0243H24.518Z",
    fill: "#523836"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.295 28.3084V33.6167H25.9451H17.3701V32.3917V30.7584V29.5334H26.7617V28.3084V25.8584H29.2117H30.4367L31.6617 28.3084H33.295Z",
    fill: "#FBCD59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.295 33.6167V28.3084H31.6617L30.4367 25.8584H29.2117M33.295 33.6167H25.9451M33.295 33.6167L31.6617 30.7584H26.7617L25.9451 32.3917M26.7617 30.35V29.5334M26.7617 29.5334H17.3701V30.7584V32.3917M26.7617 29.5334V28.3084M17.3701 32.3917V33.6167H25.9451M17.3701 32.3917H22.2701M23.0867 32.3917H25.9451M25.9451 32.3917V33.6167M26.7617 28.3084V25.8584H29.2117M26.7617 28.3084H27.9867M28.395 28.3084H29.2117M30.4367 28.3084H29.2117M29.2117 25.8584V28.3084",
    stroke: "#523836",
    strokeWidth: 0.408331
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6616 29.125H33.2949V29.9417H31.6616V29.125Z",
    fill: "#F37E98",
    stroke: "#523836",
    strokeWidth: 0.408331
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.72 25.8583H14.5117L15.7367 30.3499L24.3117 31.5749L26.3533 24.225H29.6199V23H25.5366L24.72 25.8583Z",
    fill: "#E0A825"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.145 27.0833H21.045M21.8617 27.0833H23.9033M16.5534 28.3083H17.7784M18.595 28.3083H19.82M20.2283 28.3083H23.9033M16.9617 29.125H23.495M14.5117 25.8583H24.72L25.5366 23H29.6199V24.225H26.3533L24.3117 31.5749L15.7367 30.3499L14.5117 25.8583Z",
    stroke: "#523836",
    strokeWidth: 0.408331
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8451 27.8999H29.6201V26.2666H30.0284L30.8451 27.8999Z",
    fill: "#78CDD4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5955,
    cy: 33.617,
    r: 2.24582,
    fill: "#836F61",
    stroke: "#472B29",
    strokeWidth: 0.408331
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2122,
    cy: 33.617,
    r: 2.24582,
    fill: "#836F61",
    stroke: "#472B29",
    strokeWidth: 0.408331
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5955,
    cy: 33.617,
    r: 0.816661,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2122,
    cy: 33.617,
    r: 0.816661,
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3286 36.0664H16.9619M17.7786 36.0664H21.4536M22.6786 36.0664H32.8868",
    stroke: "#472B29",
    strokeWidth: 0.408331
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco1);
export default __webpack_public_path__ + "static/media/ico1.e9e47c905ca895c44033abf192f6d982.svg";
export { ForwardRef as ReactComponent };